<template>
  <div class="personal-center-page">
    <!-- 头部banner区域 -->
    <div class="header-banner">
      <div class="banner-content">
        <img
          src="@/assets/college/bg-banner.png"
          class="banner-image"
        />
        <!-- 页面标题 -->
        <div class="page-header">
          <h1 class="page-title">个人中心</h1>
        </div>
      </div>
    </div>

    <!-- 金色banner卡片 -->
    <div class="golden-banner">
      <img
        src="@/assets/college/vip-card/card.png"
        alt="卡片背景"
        class="card-background"
      />
      <img
        :src="collegeName[productId].logoCard"
        alt="logo"
        class="logo-image"
      />
      <img
        src="@/assets/college/vip-card/vip.png"
        alt="vip"
        class="vip-image"
      />
      <img
        src="@/assets/college/vip-card/super.png"
        alt="super"
        class="super-image"
      />
      <img
        src="@/assets/college/vip-card/text.png"
        alt="text"
        class="text-image"
      />
      <!-- <div class="vip-card-text">
        <span>查看权益</span>
      </div> -->
    </div>

    <!-- 绑定账户区域 -->
    <div class="operations-section">
      <h3 class="section-title">绑定账户</h3>

      <!-- 绑定账户列表 -->
      <div class="privilege-list">
        <div
          v-for="item in privilegeList"
          :key="item.personPrivilgeId"
          class="privilege-item"
        >
          <!-- 权益头部栏 -->
          <div class="privilege-header">
            <div class="privilege-icon">
              <van-icon name="user-o" size="20" color="#fff" />
            </div>
            <span class="privilege-name">{{ item.privilegeName }}</span>
          </div>

          <!-- 账户详情 -->
          <div class="account-details">
            <div class="account-info">
              <div class="account-name">{{ item.personName }}</div>
              <div class="account-id-card">
                身份证: {{ maskIdCard(item.idCard) }}
              </div>
            </div>
            <!-- 立即查看按钮 -->
            <button class="view-btn" @click="viewPrivilege(item)">
              立即查看
            </button>
          </div>
        </div>

        <!-- 空状态 -->
        <van-empty
          v-if="!loading && privilegeList.length === 0"
          image="search"
          description="暂无绑定账户"
        />

        <!-- 加载状态 -->
        <div v-if="loading" class="loading-container">
          <van-loading type="spinner" size="20px" />
          <span>加载中...</span>
        </div>
      </div>
    </div>
    <!-- 退出登录按钮 -->
    <div class="logout-section">
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div>
  </div>
</template>

<script>
import { onSelectXinWeiLaiPersonPrivilegeList } from "@/api/client";
import { college } from "../../college/config";

export default {
  name: "ClientPersonalCenter",
  data() {
    return {
      orgName: "",
      privilegeList: [],
      loading: false,
      collegeName: college,
      productId: '0'
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    this.productId = this.$route.meta.productId || urlParams.get("productId") || localStorage.getItem("productId") || "18";
  },
  mounted() {
    this.orgName = localStorage.getItem("client_user");
    this.loadPrivilegeList();
  },
  methods: {
    async loadPrivilegeList() {
      this.loading = true;
      try {
        const params = {
          // userId:126235,
          // oldProductId:null,
        }
        if (this.productId !== '0') {
          params.productId = this.productId
        }
        const response = await onSelectXinWeiLaiPersonPrivilegeList(params);
        if (response.code === 200) {
          this.privilegeList = response.data || [];
        } else {
          this.$toast(response.msg || "加载失败");
        }
      } catch (error) {
        console.error("加载绑定账户失败:", error);
        this.$toast("加载失败");
      } finally {
        this.loading = false;
      }
    },
    maskIdCard(idCard) {
      if (!idCard) return "";
      // 身份证号脱敏：保留前6位和后4位，中间用*代替
      if (idCard.length >= 10) {
        const prefix = idCard.substring(0, 6);
        const suffix = idCard.substring(idCard.length - 4);
        const mask = "*".repeat(idCard.length - 10);
        return `${prefix}${mask}${suffix}`;
      }
      return idCard;
    },
    viewPrivilege(item) {
      // 跳转到权益详情页，传递权益信息
      this.$router.push({
        path: "/jiaJiHua/rights",
        query: {
          personPrivilgeId: item.personPrivilgeId,
          privilegeName: item.privilegeName,
          biaoJi: item.biaoJi || "",
          productId: this.productId,
        },
      });
    },
    handleLogout() {
      this.$dialog
        .confirm({
          title: "确认退出",
          message: "确定要退出登录吗？",
        })
        .then(() => {
          // 清除本地存储（使用客户端系统的key）
          localStorage.removeItem("client_token");
          localStorage.removeItem("client_user");

          this.$toast("已退出登录");
          // 跳转到登录页
          this.$router.push({
            path: "/jiaJiHua/login",
            query: {
              productId: this.productId,
            },
          })
        })
        .catch(() => {
          // 用户取消
        });
    },
  },
};
</script>

<style scoped>
.personal-center-page {
  height: 100vh;
  background: #fff;
  position: relative;
  padding-bottom: 90px; /* 为固定的退出按钮留出空间 */
  display: flex;
  flex-direction: column;
}

/* 头部banner区域 */
.header-banner {
  position: relative;
  height: 245px;
  overflow: hidden;
}

.banner-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.banner-content {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  align-items: center;
}

/* 页面标题 */
.page-header {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
  z-index: 3;
  text-align: center;
}

.page-title {
  color: white;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

/* 金色banner卡片 */
.golden-banner {
  position: relative;
  z-index: 2;
  padding: 0 20px 20px;
  margin-top: -160px;
}

.card-background {
  width: 100%;
  height: auto;
  display: block;
}
.logo-image {
  position: absolute;
  width: 200px;
  left: 40px;
  top: 20px;
}
.text-image {
  position: absolute;
  width: 280px;
  left: 40px;
  top: 80px;
}
.super-image {
  position: absolute;
  width: 50px;
  left: 40px;
  top: 115px;
}
.vip-image {
  position: absolute;
  width: 30px;
  left: 95px;
  top: 111px;
}
.vip-card-text {
  position: absolute;
  right: 40px;
  top: 145px;
  padding: 7px 10px;
  border-radius: 3px;
  background: linear-gradient(
    268deg,
    rgba(245, 196, 133, 1) 0.61%,
    rgba(254, 221, 189, 1) 97.34%
  );
  color: rgb(126, 86, 33);
  font-size: 14px;
}

/* 绑定账户区域 */
.operations-section {
  flex: 1;
  padding: 0 20px;
  background: white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 20px 0;
  flex-shrink: 0;
}

/* 绑定账户列表 */
.privilege-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.privilege-item {
  position: relative;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex-shrink: 0;
  min-height: 120px;
}

/* 权益头部栏 */
.privilege-header {
  display: flex;
  align-items: center;
  padding: 12px 15px;
  background: linear-gradient(
    89.03deg,
    rgba(246, 198, 137, 1) 0.12%,
    rgba(254, 221, 189, 0.3) 94.54%
  );
  border-radius: 12px 12px 0 0;
  gap: 10px;
  flex-shrink: 0;
  min-height: 50px;
}

.privilege-icon {
  width: 32px;
  height: 32px;
  background: #8b4513;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.privilege-name {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  flex: 1;
  min-width: 0;
}

/* 账户详情 */
.account-details {
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  min-height: 70px;
}

.account-info {
  flex: 1;
  min-width: 0; /* 允许文本截断 */
}

.account-name {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.4;
  word-break: break-all;
}

.account-id-card {
  font-size: 14px;
  color: #999;
  line-height: 1.4;
  word-break: break-all;
}

/* 立即查看按钮 */
.view-btn {
  background: #bb7849;
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
  flex-shrink: 0;
  white-space: nowrap;
  min-width: 80px;
}

.view-btn:hover {
  background: #a5693a;
  transform: scale(1.05);
}

.view-btn:active {
  transform: scale(0.98);
}

/* 加载状态 */
.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 30px 0;
  color: #999;
  font-size: 14px;
}

/* 退出登录按钮 */
.logout-section {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  /* background: white; */
  /* box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1); */
  z-index: 100;
}

.logout-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(
    -57.77deg,
    rgba(246, 201, 144, 1) 9.65%,
    rgba(253, 218, 181, 1) 89.45%
  );
  border: none;
  border-radius: 25px;
  color: #8b4513;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.3);
}

.logout-btn:hover {
  background: linear-gradient(135deg, #c19b2e 0%, #e6c035 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 175, 55, 0.4);
}

.logout-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 375px) {
  .header-banner {
    height: 200px;
  }

  .golden-banner {
    padding: 0 15px 15px;
  }

  .account-details {
    padding: 12px;
    gap: 10px;
  }

  .view-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>
